
import { MapLocation } from '@/types/location';

// UFC Gym Locations
export const ufcGyms: MapLocation[] = [
  {
    id: 22001,
    name: "UFC Gym - Riyadh (As Sulimaniyah)",
    type: "Gym",
    devices: 9,
    coordinates: [24.703181411380143, 46.701280519035656],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 22002,
    name: "UFC Gym - Riyadh (Al Olaiya)",
    type: "Gym",
    devices: 7,
    coordinates: [24.70174854603929, 46.676434338947374],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
